export const ADMIN_TOKEN = 'adminToken'
export const ADMIN_ID = 'adminId'
export const ADMIN_NAME = 'adminName'
export const AUTH_MENU = 'authMenu'
export const MENU_TAB_ROUTES = 'menuTabRoutes'
export const THIS_MENU_ROUTE = 'thisMenuRoute'
export const USER_INFO = 'userInfo'
